export default "__VITE_ASSET__6ea5x9cN__"